import { useCallback } from "react";
import { format } from "date-fns";
// @ts-ignore package has no types
import HtmlParser from "react-html-parser";
import GetAppIcon from "@material-ui/icons/GetApp";
import { ReportContainer } from "pages/patient-results/styles";
import { RiskReportProvider, useRiskReport } from "context/risk-report";
import { downloadPdf } from "helpers/download-pdf";
import { Loading } from "components/loading";
import { Button } from "storybook/components/button";
import { Typography } from "storybook/components/typography";
import { DownloadButtonWrapper, DateWrapper } from "./styles";

export function RiskReportContent() {
  const { reportHtml, reportPdf, reportData, isLoading } = useRiskReport();
  const date = reportData?.date || "";

  const handleDownloadClick = useCallback(() => {
    downloadPdf({ reportPdf });
  }, [reportPdf]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ReportContainer role="article">
      {date && (
        <DateWrapper>
          <Typography variant="body2" theme="default" color="ciqBrandDark">
            <strong>
              <span>Date:</span>{" "}
              <time dateTime={format(new Date(date as string), "yyyy-MM-dd")}>
                {format(new Date(date as string), "MM/dd/yyyy")}
              </time>
            </strong>
          </Typography>
        </DateWrapper>
      )}
      <DownloadButtonWrapper>
        <Button
          theme="default"
          variant="outlined"
          fullWidth={true}
          startIcon={<GetAppIcon />}
          onClick={handleDownloadClick}
        >
          Download
        </Button>
      </DownloadButtonWrapper>
      <div className="notranslate">{HtmlParser(reportHtml)}</div>
    </ReportContainer>
  );
}

export function RiskReport() {
  return (
    <RiskReportProvider>
      <RiskReportContent />
    </RiskReportProvider>
  );
}
